<template>
    <div class="form-check">
        <label class="form-label form-check-label cursor-pointer" :for="id">
            <input
                class="form-check-input !h-4 !w-4"
                :id="id"
                :value="modelValue"
                :checked="modelValue"
                type="checkbox"
                @change="$emit('update:modelValue', $event.target.checked)"
            />
            {{ label }}
        </label>
        <div v-if="invalidFeedback" class="text-small text-danger" v-text="invalidFeedback" />
        <div v-if="description" class="form-text" v-html="description" />
    </div>
</template>

<script setup>
defineProps({
    id: String,
    modelValue: {
        default: null,
    },
    label: String,
    description: String,
    invalidFeedback: {
        type: String,
        default: '',
    },
});

defineEmits(['update:modelValue']);
</script>
